(() => {
  'use strict';

  const isSpanishTrackingPage = () =>
    window.location.pathname.replace(/\/+$/, '').toLowerCase() === '/apps/17track' &&
    /^es(?:-|$)/i.test(document.documentElement.lang);

  if (!isSpanishTrackingPage()) return;

  const start = () => {
    const main = document.getElementById('MainContent');
    if (!main) return;

    const generatedLabels = new WeakMap();
    let scheduled = false;

    const enhance = () => {
      scheduled = false;
      if (!isSpanishTrackingPage()) return;

      main.querySelectorAll('h1.yq-track-page-title').forEach((heading) => {
        if (heading.textContent.trim() === 'Seguimiento de su pedido') {
          heading.textContent = 'Sigue tu pedido';
        }
      });

      main.querySelectorAll('button.ant-btn[type="submit"] span').forEach((label) => {
        if (label.textContent.trim() === 'PISTA') {
          label.textContent = 'Ver estado';
        }
      });

      main.querySelectorAll('input.ant-input[placeholder]').forEach((input) => {
        if (input.type === 'hidden') return;
        const placeholder = input.getAttribute('placeholder')?.trim();
        const currentLabel = input.getAttribute('aria-label')?.trim();
        const generatedLabel = generatedLabels.get(input);
        const hasOtherName = Boolean(
          input.getAttribute('aria-labelledby')?.trim() ||
          [...(input.labels || [])].some((label) => label.textContent.trim()) ||
          input.getAttribute('title')?.trim()
        );

        // Respect labels supplied by the app, including labels added on a later render.
        if (hasOtherName || !placeholder) {
          if (generatedLabel && currentLabel === generatedLabel) {
            input.removeAttribute('aria-label');
          }
          generatedLabels.delete(input);
          return;
        }
        if (currentLabel && currentLabel !== generatedLabel) return;
        if (currentLabel !== placeholder) input.setAttribute('aria-label', placeholder);
        generatedLabels.set(input, placeholder);
      });
    };

    const observer = new MutationObserver(() => {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(enhance);
    });

    // React may replace children or update text nodes. Our aria attributes are not observed.
    observer.observe(main, { childList: true, characterData: true, subtree: true });
    enhance();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
